import { apiRequest } from "./_api";

export async function createFiles(
  createFilesDto: CreateFilesDto
): Promise<ReadFilesDto> {
  return await apiRequest<ReadFilesDto>(
    "post",
    "/files/create",
    createFilesDto
  );
}

export async function getFilesListByReportUuidAndSearch(
  drive: boolean,
  reportUuid: string | null,
  reportIssuesUuid: string | null,
  search?: string
): Promise<ListFilesDto> {
  let query = "?";
  query += `drive=${drive}&`;
  query += reportUuid ? `reportUuid=${reportUuid}&` : "";
  query += reportIssuesUuid ? `reportIssuesUuid=${reportIssuesUuid}&` : "";
  query += search ? `search=${search}` : "";

  return await apiRequest<ListFilesDto>("get", `/files/list-by-report${query}`);
}

export async function getStorageListByFilesUuidAndSearch(
  filesUuid: string,
  search?: string
): Promise<ListStorageByFilesUuidDto> {
  let query = "?";
  query += filesUuid ? `filesUuid=${filesUuid}&` : "";
  query += search ? `search=${search}` : "";

  return await apiRequest<ListStorageByFilesUuidDto>(
    "get",
    `/files/list-storage-by-files-uuid${query}`
  );
}

export async function updateFiles(
  uuid: string,
  updateFilesDto: UpdateFilesDto
): Promise<ReadFilesDto> {
  let query = "?";
  query += uuid ? `uuid=${uuid}` : "";

  return await apiRequest<ReadFilesDto>(
    "put",
    `/files/update${query}`,
    updateFilesDto
  );
}

export async function deleteFiles(uuid: string): Promise<ReadFilesDto> {
  let query = "?";
  query += uuid ? `uuid=${uuid}` : "";

  return await apiRequest<ReadFilesDto>("delete", `/files/soft-delete${query}`);
}

export async function restoreFiles(uuid: string): Promise<ReadFilesDto> {
  let query = "?";
  query += uuid ? `uuid=${uuid}` : "";

  return await apiRequest<ReadFilesDto>("put", `/files/restore${query}`);
}
